import { SamsScope } from "./samsVbl";

export interface PdfData {
  samsId: string;
  authToken?: string;
  scope: SamsScope;
  gameData: GameData;
  challenges: Challenge[];
  challengesUsed: RemainingChallenges;
}

type GameData = {
  gameNumber?: string;
  gameStartDateTime: number;
  location?: string;
  competition?: Competition;
  team1: Team;
  team2: Team;
  gameStartVideoOffset?: number;
  youtubeId?: string;
  scoresheetPdfUrl: string;
};

export interface Challenge {
  id: string;
  team: TeamReference | "ref";
  set: number;
  scoreRallyStart: Score;
  scoreRallyEnd?: Score;
  scoreAfterChallenge: Score;
  typeOfChallenge: ChallengeType;
  challengeResult: ChallengeResults;
}

export type ChallengeResults = "unresolvable" | TeamReference;

export type TeamReference = "team1" | "team2";

export type Score = {
  [k in TeamReference]: number;
};

export interface Team {
  shortName: string;
  longName: string;
  clubCode?: string;
  iconUrl?: string;
}

export const rootChallengeTypes = [
  {
    id: "antenna",
    invertible: true,
  },
  {
    id: "in-out",
    invertible: false,
  },
  {
    id: "blocktouch",
    invertible: false,
  },
  {
    id: "foot-fault",
    invertible: true,
  },
  {
    id: "floor-touch",
    invertible: true,
  },
  {
    id: "last-touch",
    invertible: false,
  },
  {
    id: "nettouch",
    invertible: true,
  },
] as const;

type RootEntry = (typeof rootChallengeTypes)[number];

type DistributeChallengeType<T extends RootEntry> = T extends {
  invertible: true;
}
  ? T["id"] | `no-${T["id"]}`
  : T["id"];

export type ChallengeType = DistributeChallengeType<RootEntry>;

export const ChallengeTypes = rootChallengeTypes.flatMap((ct) => {
  if (ct.invertible) {
    return [ct.id, `no-${ct.id}`] as const as ChallengeType[];
  }
  return [ct.id] as const as [ChallengeType];
}) as ChallengeType[];

export type RemainingChallenges = {
  [set in string]: Score;
};

export interface Competition {
  id: string;
  gender: string;
  name: string;
  shortName: string;
}
